/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { CameraSettings } from "../../mission_camera_settings";

export const protobufPackage = "skills";

/** Arguments for the SetCameraSettings action. */
export interface SetCameraSettingsActionArgs {
  /** Camera settings to apply */
  cameraSettings: CameraSettings | undefined;
}

/** State data for the SetCameraSettings action. */
export interface SetCameraSettingsActionStateData {
}

/** Result data for the SetCameraSettings action. */
export interface SetCameraSettingsResultData {
  /** List of settings that failed to be applied */
  failedSettings: string[];
}

function createBaseSetCameraSettingsActionArgs(): SetCameraSettingsActionArgs {
  return { cameraSettings: undefined };
}

export const SetCameraSettingsActionArgs = {
  encode(message: SetCameraSettingsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetCameraSettingsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCameraSettingsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCameraSettingsActionArgs {
    return {
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
    };
  },

  toJSON(message: SetCameraSettingsActionArgs): unknown {
    const obj: any = {};
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCameraSettingsActionArgs>, I>>(base?: I): SetCameraSettingsActionArgs {
    return SetCameraSettingsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCameraSettingsActionArgs>, I>>(object: I): SetCameraSettingsActionArgs {
    const message = createBaseSetCameraSettingsActionArgs();
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    return message;
  },
};

function createBaseSetCameraSettingsActionStateData(): SetCameraSettingsActionStateData {
  return {};
}

export const SetCameraSettingsActionStateData = {
  encode(_: SetCameraSettingsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetCameraSettingsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCameraSettingsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCameraSettingsActionStateData {
    return {};
  },

  toJSON(_: SetCameraSettingsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCameraSettingsActionStateData>, I>>(
    base?: I,
  ): SetCameraSettingsActionStateData {
    return SetCameraSettingsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCameraSettingsActionStateData>, I>>(
    _: I,
  ): SetCameraSettingsActionStateData {
    const message = createBaseSetCameraSettingsActionStateData();
    return message;
  },
};

function createBaseSetCameraSettingsResultData(): SetCameraSettingsResultData {
  return { failedSettings: [] };
}

export const SetCameraSettingsResultData = {
  encode(message: SetCameraSettingsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.failedSettings) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetCameraSettingsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCameraSettingsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.failedSettings.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCameraSettingsResultData {
    return {
      failedSettings: globalThis.Array.isArray(object?.failedSettings)
        ? object.failedSettings.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SetCameraSettingsResultData): unknown {
    const obj: any = {};
    if (message.failedSettings?.length) {
      obj.failedSettings = message.failedSettings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCameraSettingsResultData>, I>>(base?: I): SetCameraSettingsResultData {
    return SetCameraSettingsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCameraSettingsResultData>, I>>(object: I): SetCameraSettingsResultData {
    const message = createBaseSetCameraSettingsResultData();
    message.failedSettings = object.failedSettings?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
